import { useState, useEffect, useCallback } from 'react';
import api from '../api';

const ACK_KEY = 'polkdesq_ai_disclosure_ack';

/**
 * One-time AI disclosure consent (DPDP). Server-side ack is the source of
 * truth (provable consent); localStorage is a read-cache to skip refetches.
 */
export function useAiDisclosure() {
  const [acknowledged, setAcknowledged] = useState(() => {
    try { return localStorage.getItem(ACK_KEY) === 'true'; } catch { return false; }
  });
  const [text, setText] = useState('');

  useEffect(() => {
    if (acknowledged) return undefined;
    let alive = true;
    api.get('/privacy/ai-disclosure')
      .then((res) => {
        if (!alive) return;
        setText(res.data?.text || '');
        if (res.data?.acknowledged) {
          try { localStorage.setItem(ACK_KEY, 'true'); } catch { /* private mode */ }
          setAcknowledged(true);
        }
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [acknowledged]);

  const acknowledge = useCallback(async () => {
    setAcknowledged(true);
    try { localStorage.setItem(ACK_KEY, 'true'); } catch { /* private mode */ }
    try { await api.post('/privacy/ai-disclosure/ack'); } catch { /* retried on next load */ }
  }, []);

  return { acknowledged, text, acknowledge };
}
